/**
 * Footer Google Maps Implementation
 */

(function() {
    'use strict';

    let mapsInitialized = false;

    // Create custom marker content for AdvancedMarkerElement
    function createMarkerContent(iconUrl) {
        const markerDiv = document.createElement('div');
        markerDiv.innerHTML = `<img src="${iconUrl}" style="width: 40px; height: 40px;">`;
        return markerDiv;
    }

    // Main initialization function
    function initializeMaps() {
        if (mapsInitialized) return;
        mapsInitialized = true;

        // Check if map container exists
        const mapContainers = document.querySelectorAll('.footer-map');
        if (!mapContainers.length) return;

        // Initialize each map container
        mapContainers.forEach(container => {
            const mapData = {
                address: container.dataset.address || '',
                lat: parseFloat(container.dataset.lat) || null,
                lng: parseFloat(container.dataset.lng) || null,
                markerIcon: container.dataset.markerIcon || ''
            };

            if (mapData.lat && mapData.lng) {
                initializeMap(container, mapData);
            } else if (mapData.address) {
                // If no coordinates, we need to geocode the address
                geocodeAndInitialize(container, mapData);
            }
        });
    }

    // Initialize map with coordinates
    function initializeMap(container, mapData) {
        // For now, we will use the legacy Marker approach to keep POI hiding functionality
        // AdvancedMarkerElement requires either:
        // 1. A mapId (which conflicts with inline styles)
        // 2. Cloud-based styling in Google Cloud Console
        // Until we set up cloud-based styling, we use legacy markers
        
        const mapOptions = {
            center: { lat: mapData.lat, lng: mapData.lng },
            zoom: 15,
            disableDefaultUI: true,
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            styles: getNormalMapStyleWithoutPOIs()
        };

        const map = new google.maps.Map(container, mapOptions);

        // Use legacy Marker to maintain POI hiding functionality
        var marker = new google.maps.Marker({
            position: { lat: mapData.lat, lng: mapData.lng },
            map: map,
            icon: {
                url: mapData.markerIcon,
                scaledSize: new google.maps.Size(40, 40),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(20, 20)
            },
            title: 'Uit Holland'
        });

        // Add click listener to open directions
        marker.addListener('click', function() {
            const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${mapData.lat},${mapData.lng}`;
            window.open(directionsUrl, '_blank');
        });

        // Info window with address
        if (mapData.address) {
            const infoWindow = new google.maps.InfoWindow({
                content: '<div style="padding: 0 10px 10px 10px; font-family: Roboto, sans-serif; color: #333;">' +
                    '<strong>Uit Holland</strong><br>' +
                    mapData.address +
                '</div>'
            });
            
            // Remove the close button completely
            google.maps.event.addListener(infoWindow, 'domready', function() {
                const closeBtn = document.querySelector('.gm-ui-hover-effect');
                if (closeBtn) {
                    closeBtn.style.display = 'none';
                }
            });

            marker.addListener('mouseover', function() {
                infoWindow.open(map, marker);
            });

            marker.addListener('mouseout', function() {
                infoWindow.close();
            });
        }
    }

    // Geocode address and initialize map
    function geocodeAndInitialize(container, mapData) {
        const geocoder = new google.maps.Geocoder();
        
        geocoder.geocode({ address: mapData.address }, function(results, status) {
            if (status === 'OK' && results[0]) {
                const location = results[0].geometry.location;
                mapData.lat = location.lat();
                mapData.lng = location.lng();
                initializeMap(container, mapData);
            } else {
                console.error('Geocode failed: ' + status);
                container.innerHTML = '<p style="padding: 20px; text-align: center; color: #999;">Map unavailable</p>';
            }
        });
    }

    // Normal map style without POIs
    function getNormalMapStyleWithoutPOIs() {
        return [
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "poi.business",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "poi.attraction",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "poi.government",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "poi.medical",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "poi.park",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "poi.place_of_worship",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "poi.school",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "poi.sports_complex",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "transit.station",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            },
            {
                "featureType": "transit.line",
                "elementType": "all",
                "stylers": [{ "visibility": "off" }]
            }
        ];
    }
    // Expose initialization function globally
    window.initializeMaps = initializeMaps;
})();

// Global callback for Google Maps API
window.initFooterMap = function() {
    // Initialize maps when Google Maps API is loaded
    if (window.initializeMaps) {
        window.initializeMaps();
    }
};

// Also initialize on DOMContentLoaded as fallback
document.addEventListener('DOMContentLoaded', function() {
    // Wait a bit for Google Maps to load
    setTimeout(function() {
        if (window.google && window.google.maps && window.initializeMaps) {
            window.initializeMaps();
        }
    }, 1000);
});